import { useIntl } from "react-intl";
import { getInternalAppType } from "utils/brandingUtils";
import { selectUiBranding } from "store/reducers/branding";
import { useSelector } from "react-redux";

// Hook for getting translated text (with optional interpolation values)
export function useTranslation() {
  const intl = useIntl();
  const uiBranding = useSelector(selectUiBranding);
  /**
   * Translates a message id.
   * Supports interpolation via react-intl values, e.g.:
   * translate("key", { productName: "Skovkortet.dk" })
   */
  const translate = (
    key: string,
    values?: Record<string, string | number | boolean | null | undefined>,
  ) => {
    const safeKey = key === "" ? "empty-key" : key;

    const inputValues = {
      ...values,
      productName: values?.productName ?? uiBranding?.appName ?? "Forsler.com",
    };

    // react-intl supports interpolation by passing `values` as the second argument
    return intl.formatMessage({ id: safeKey }, inputValues);
  };

  return { translate };
}

export function mapFromI18nToCountry(i18n: string) {
  switch (i18n) {
    case "da":
      return "dk";
    case "no":
      return "no";
    case "en":
      return "gb";
    case "es":
      return "es";
    case "fr":
      return "fr";
    case "it":
      return "it";
    case "de":
      return "de";
    default:
      return "gb";
  }
}
